import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import type { Media } from "../content/media.service";

const PATH = "media";

type PutMediaPayload = Partial<Media> & {
  id: number;
  foreign_key?: string | null;
};

@Injectable({
  providedIn: "root",
})
export class MediaHandlerService {
  constructor(private APIService: ApiService) {}

  getAll(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      [key: string]: any;
    },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  signUpload(
    masterAccountID: number,
    file: {
      file: { name: string; size: number; type: string };
      folder: string;
      account_app_id?: number | null;
    },
  ) {
    return this.APIService.post(`${PATH}/${masterAccountID}/sign-upload`, file);
  }

  deleteUpload(
    masterAccountID: number,
    payload: { url?: string; aws_key?: string; account_app_id?: number | null },
  ) {
    return this.APIService.post(`${PATH}/${masterAccountID}/delete-upload`, payload);
  }

  postMedia(
    masterAccountID: number,
    image: {
      aws_key: string;
      context: string;
      name: string;
      description: string;
      url: string;
    },
  ) {
    return this.APIService.post(`${PATH}/${masterAccountID}`, image);
  }

  deleteMedia(masterAccountID: number, mediaID: number) {
    return this.APIService.delete(`${PATH}/${masterAccountID}/${mediaID}`);
  }

  putMedia(masterAccountID: number, image: PutMediaPayload) {
    return this.APIService.put(`${PATH}/${masterAccountID}`, image);
  }
}
